const Style = {

  auth: 'min-h-screen bg-sg-bg bg-gradient-to-b from-sg-blue-tint via-sg-bg to-white',

}

export default Style;
